<div class="wrapper-content-editor">
  <input id="product_group" data-product-group="" type="hidden" />
  <!--<pre>{{contentSchema | json}}
    </pre>
    <pre>{{contentData | json}}
    </pre>

    <pre>{{currentContentData | json}}</pre>
    <pre>{{lastSavedContentData | json}}</pre>

    {{customContentDataIsChanged}}
    -->

  <div class="section-title">
    <div class="row">
      <div class="col">
        <div class="d-flex align-items-center">
          <a
            routerLink="/dashboard/design"
            class="btn btn-back" [attr.aria-label]="'Back' | translate">
            <i class="fi-rr-arrow-alt-left"></i>
          </a>
          <div class="title" [attr.data-parent]="'Storefront' | translate">{{ "Site Editor" | translate }}</div>
        </div>
      </div>
      <div class="col text-right" *ngIf="!isMobileView">
        <div class="d-inline-block">
          <div class="d-inline-block w-100">
            <ng-container *ngIf="!fullpageMode">
              <button class="btn btn-editor-secondary" (click)="toggleFullpage()">
                <i class="fi fi-rr-expand"></i>
                {{ "Fullpage Mode" | translate }}
              </button>
            </ng-container>
            <ng-container *ngIf="fullpageMode">
              <button class="btn btn-editor-secondary" (click)="toggleFullpage()">
                <i class="fi fi-rr-compress"></i>
                {{ "Exit Fullpage Mode" | translate }}
              </button>
            </ng-container>
            <button class="btn btn-editor-secondary mx-2" (click)="viewStore()">
              <i class="fi fi-rr-shop"></i>
              {{ "Visit Store" | translate }}
            </button>

            <button
              class="btn btn-primary"
              [disabled]="customContentDataIsChanged ? 'true' : null"
              [class]="{
                'is-loading':
                  !contentDataReady || customContentDataIsChanged
                    ? 'true'
                    : null
              }"
              (click)="handleSaveChanges($event)"
            >
              <i class="fi fi-rr-disk"></i>
              {{ "Publish" | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!--<div class="section-title row">
    <div class="section-btn">
      <a
        class="btn btn-back rounded-circle"
        routerLink="/dashboard/design"
      >
        <i class="fi-rr-arrow-alt-left"></i>
      </a>
    </div>
    <div>
      <h1 class="title">{{ "Site Editor" | translate }}</h1>
    </div>

    <div class="form-group mb-0 ml-3">
      <div class="d-inline-block w-100">
        <ng-container *ngIf="!fullpageMode">
          <button
            class="btn btn-outline-success mr-2"
            (click)="toggleFullpage()"
          >
            <i class="fi fi-rr-expand mr-2"></i>
            {{ "Fullpage Mode" | translate }}
          </button>
        </ng-container>
        <ng-container *ngIf="fullpageMode">
          <button class="btn btn-success mr-2" (click)="toggleFullpage()">
            <i class="fi fi-rr-compress mr-2"></i>
            {{ "Exit Fullpage Mode" | translate }}
          </button>
        </ng-container>
        <a [href]="store_url" class="btn btn-outline-info" target="_blank">
          <i class="fi fi-rr-link mr-2"></i>
          {{ "Visit Store" | translate }}</a
        >

        <button
          class="btn btn-primary"
          [disabled]="customContentDataIsChanged ? 'true' : null"
          [class]="{ 'is-loading': !contentDataReady }"
          (click)="handleSaveChanges($event)"
        >
          <i class="fi fi-rr-disk mr-2 align-middle"></i>
          {{ "Publish" | translate }}
        </button>
      </div>
    </div>
  </div>-->

  <div class="section-main">
    <div
      class="content-editor-container fullpage-mode"
      [class]="{ 'fullpage-mode': fullpageMode }"
      *ngIf="!isMobileView"
    >
      <div class="content-editor-top-controller" *ngIf="fullpageMode">
        <div class="card">
          <div class="row">
            <div class="col">
              <button class="btn btn-editor-secondary" (click)="toggleFullpage()">
                <i class="fi fi-rr-compress"></i>
                {{ "Exit Fullpage Mode" | translate }}
              </button>

              <a
                [href]="store_url"
                class="btn btn-editor-secondary mx-2"
                target="_blank"
              >
                <i class="fi fi-rr-link"></i>
                {{ "Visit Store" | translate }}</a
              >
            </div>
            <div class="col text-right">
              <button
                class="btn btn-primary"
                [disabled]="customContentDataIsChanged ? 'true' : null"
                [class]="{
                  'is-loading':
                    !contentDataReady || customContentDataIsChanged
                      ? 'true'
                      : null
                }"
                (click)="handleSaveChanges($event)"
              >
                <i class="fi fi-rr-disk"></i>
                {{ "Publish" | translate }}
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="content-editor-content-wrapper">
        <div class="content-editor-side-controller" id="first">
          <div class="side-control">
            <div class="row">
              <div class="col">
                <div class="side-header">
                  <h4 class="float-left">
                    <i class="fi fi-rr-settings-sliders mr-2"></i
                    >{{
                      "Customize
                      Options" | translate
                    }}
                  </h4>
                </div>
              </div>
            </div>

            <ng-container *ngIf="sidePanelIsReady; else sideBarLoading">
              <div class="row" [class]="{ 'is-loading': !contentDataReady }">
                <div class="col">
                  <div class="content-language-selector">
                    <div ngbDropdown class="d-inline-block w-100">
                      <button
                        class="btn btn-outline-primary w-100"
                        id="dropdownBasic2"
                        ngbDropdownToggle
                      >
                        {{ selectedLanguage?.language_name }}
                      </button>
                      <div
                        ngbDropdownMenu
                        aria-labelledby="dropdownBasic2"
                        class="custom-dropdown"
                      >
                        <button
                          ngbDropdownItem
                          *ngFor="let language of languages"
                          (click)="changeLanguage(language)"
                        >
                          {{ language.language_name }}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="form-wrapper"
                id="form-wrapper"
                [class]="{ 'is-loading': !contentDataReady }"
              >
                <form
                  id="content-editor-event-transport"
                  (formUpdate)="handleFormUpdate($event)"
                  (formBlur)="handleFormBlur($event)"
                  (formFocus)="handleFormFocus($event)"
                ></form>
                <!--<form class="content-editor-form" id="content-editor-form" name="content-editor-form" (formUpdate)="handleFormUpdate($event)"></form>-->
                <!--<form class="content-editor-form" id="content-editor-form" name="content-editor-form" ></form>-->
              </div>
            </ng-container>
            <ng-template #sideBarLoading>
              <div class="row">
                <div class="col text-center">
                  <div class="loading-spinner col-12 mt-5">
                    <mat-spinner
                      class="mx-auto my-5"
                      [diameter]="50"
                    ></mat-spinner>
                  </div>
                </div>
              </div>
            </ng-template>

            <div class="row">
              <div class="col">
                <form
                  id="media-selector-event-transport"
                  (setImageInputID)="handleSetImageInputID($event)"
                >
                  <media-selector
                    id="media-selector-embed"
                    [(mediaID)]="lastMediaID"
                    [(imgURL)]="lastImageURL"
                    (mediaChanged)="handleMediaChanged($event)"
                    class="d-none"
                  ></media-selector>
                </form>

                <form
                  id="location-selector-event-transport"
                  (setLocationInputID)="handleSetLocationInputID($event)"
                  (setCurrentLocation)="handleSetCurrentLocation($event)"
                >
                  <location-selector
                    id="location-selector-embed"
                    [(coordinate)]="coordinate"
                    (coordinateChange)="handleCoordinateChanged($event)"
                    class="d-none"
                  >
                  </location-selector>
                </form>

                <form
                  id="ai-assistant-event-transport"
                  (openAIAssistantModal)="handleOpenAIAssistantModal($event)"
                ></form>

              </div>
            </div>
          </div>
        </div>
        <div id="separator" (mousedown)="startPanelResize($event)"></div>
        <div class="content-editor-store-preview" id="second">
          <div class="card">
            <div class="row">
              <div class="col store-preview-column">
                <div class="store-preview">
                  <iframe id="editor-preview" [src]="safe_store_url"></iframe>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="isMobileView">
      <div class="card-title-top text-center font-weight-bold mt-2">
        <div class="col-12">
          <div class="text-success mt-4">
            <i class="fi fi-rr-sensor-alert fa-7x"></i>
          </div>
          <p class="font-weight-bold">
            {{
              "Important Notice"
                | translate
            }}:
          </p>
          <p class="lead-para">
            {{
              "For an optimal viewing experience, we recommend opening this page on a desktop or a larger screen. Currently, the page may not display correctly on mobile devices. Thank you for your understanding."
                | translate
            }}
          </p>
        </div>
      </div>
    </div>
  </div>
</div>
